import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { REGISTRATION_URL, SITE } from "@/lib/config";

export default function FinalCTA() {
    return (
        <section
            data-testid="final-cta-section"
            className="bg-[#082050] text-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
                    <div className="lg:col-span-8">
                        <div className="text-xs uppercase tracking-widest text-white/60 mb-6">
                            Únete a ASATTA
                        </div>
                        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight">
                            Suma tu alojamiento al sector que representa a Tarifa.
                        </h2>
                        <p className="mt-6 text-white/70 text-lg max-w-2xl">
                            Por {SITE.quota} formas parte de una asociación que trabaja
                            cada día por la calidad, la visibilidad y la sostenibilidad de
                            los alojamientos turísticos de Tarifa.
                        </p>
                    </div>
                    <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-4">
                        <a
                            href={REGISTRATION_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="btn-hazte-socio-final"
                            className="inline-flex items-center justify-between bg-white text-[#082050] px-8 py-5 text-sm font-medium hover:bg-white/90 transition-transform hover:-translate-y-0.5"
                        >
                            Hazte socio ahora
                            <ArrowRight size={16} />
                        </a>
                        <Link
                            to="/contacto"
                            data-testid="btn-contact-final"
                            className="inline-flex items-center justify-between border border-white/30 text-white px-8 py-5 text-sm font-medium hover:bg-white/5"
                        >
                            Tengo dudas, contactar
                            <ArrowRight size={16} />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
